import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SLDSIcon from '@salesforce/design-system-react/components/icon';
import classNames from 'classnames';
import kebabCase from 'lodash.kebabcase';
import IconSettingsInternal from '@salesforce/design-system-react/components/icon-settings';
import parsedComponents from '../../utilities/library-parsers';

const {
    componentsStatusProdSorted,
    componentsStatusPrototypeSorted
} = parsedComponents;

export const ComponentsLayout = props => {
    const section = props.params && props.params.section;
    const componentPath = props.params && props.params.component;
    const page = section || componentPath;

    const isGettingStartedSection =
        section === 'getting-started' ||
        section === 'contributing' ||
        section === 'development-process';

    return (
        <IconSettingsInternal iconPath="/assets/icons">
            <div className="site slds-grid stage slds-grid--vertical slds-nowrap">
                <div className="site-skip-content slds-p-vertical--medium slds-p-horizontal--x-large slds-x-small-show-only bb-gray">
                    <a href="#navigation">Skip to Navigation</a>
                </div>
                <div className="site-skip-content slds-p-vertical--medium slds-p-horizontal--x-large slds-small-show-only bb-gray">
                    <a href="#navigation">Skip to Navigation</a>
                </div>
                <main className="stage-main slds-grid slds-wrap slds-grow">
                    <aside className="region region--main slds-grow slds-size--1-of-1 slds-medium-size--4-of-12 slds-large-size--3-of-12 slds-col-rule--right slds-order--2 slds-small-order--2 slds-medium-order--1 slds-large-order--1">
                        <nav id="navigation" role="navigation" tabIndex="-1">
                            <section id="top" className="demo-only">
                                <header className="bg-lt-gray bb-gray slds-clearfix slds-p-vertical--small slds-p-horizontal--medium">
                                    <Link
                                        to="/"
                                        className="slds-float--left slds-text-link--reset slds-p-vertical--x-small"
                                    >
                                        <div className="slds-media slds-media--center">
                                            <span className="slds-media__figure site-logo">
                                                Salesforce
                                            </span>
                                            <div className="slds-media__body">
                                                <span
                                                    className="slds-text-heading--small slds-m-right--small slds-align-middle"
                                                    title="Record Title"
                                                >
                                                    Lightning Design System{' '}
                                                    <br />
                                                    <i>for</i> React
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </header>
                            </section>
                            <ul className="site-navigation slds-navigation-list--vertical slds-has-block-links--space">
                                <li
                                    className={classNames('slds-list__item', {
                                        'slds-is-open': isGettingStartedSection,
                                        'slds-is-selected': isGettingStartedSection,
                                        'is-closed': !isGettingStartedSection
                                    })}
                                    data-slds-nav-children="true"
                                >
                                    <Link
                                        className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                        to="/getting-started/"
                                    >
                                        <span className="slds-media slds-media--center">
                                            <span className="slds-media__body">
                                                Getting Started
                                            </span>
                                            <span className="slds-media__figure--reverse">
                                                <SLDSIcon
                                                    assistiveText=""
                                                    category="utility"
                                                    className="icon__svg"
                                                    name={classNames(
                                                        {
                                                            down: isGettingStartedSection
                                                        },
                                                        {
                                                            right: !isGettingStartedSection
                                                        }
                                                    )}
                                                    inverse={false}
                                                    name={classNames(
                                                        {
                                                            down: isGettingStartedSection
                                                        },
                                                        {
                                                            right: !isGettingStartedSection
                                                        }
                                                    )}
                                                    size="small"
                                                />
                                            </span>
                                        </span>
                                    </Link>
                                    <ul className="slds-navigation-list--vertical slds-has-block-links--space slds-is-nested">
                                        <li
                                            className={classNames(
                                                'slds-list__item',
                                                {
                                                    'slds-is-active':
                                                        section ===
                                                        'getting-started'
                                                }
                                            )}
                                        >
                                            <Link
                                                className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                                to="/getting-started/"
                                            >
                                                <span className="slds-media slds-media--center">
                                                    <span className="slds-media__body">
                                                        Overview
                                                    </span>
                                                </span>
                                            </Link>
                                        </li>
                                        <li
                                            className={classNames(
                                                'slds-list__item',
                                                {
                                                    'slds-is-active':
                                                        section ===
                                                        'contributing'
                                                }
                                            )}
                                        >
                                            <Link
                                                className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                                to="/contributing/"
                                            >
                                                <span className="slds-media slds-media--center">
                                                    <span className="slds-media__body">
                                                        Contributing
                                                    </span>
                                                </span>
                                            </Link>
                                        </li>
                                        <li
                                            className={classNames(
                                                'slds-list__item',
                                                {
                                                    'slds-is-active':
                                                        section ===
                                                        'development-process'
                                                }
                                            )}
                                        >
                                            <Link
                                                className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                                to="/development-process/"
                                            >
                                                <span className="slds-media slds-media--center">
                                                    <span className="slds-media__body">
                                                        Our Development Process
                                                    </span>
                                                </span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>

                                <li
                                    className={classNames(
                                        'slds-list__item',
                                        { 'slds-is-open': componentPath },
                                        { 'slds-is-selected': componentPath },
                                        { 'is-closed': !componentPath }
                                    )}
                                    data-slds-nav-children="true"
                                >
                                    <Link to="/components/">
                                        <span className="slds-media slds-media--center">
                                            <span className="slds-media__body">
                                                Components
                                            </span>
                                            <span className="slds-media__figure--reverse">
                                                <SLDSIcon
                                                    className="icon__svg"
                                                    assistiveText=""
                                                    category="utility"
                                                    inverse={false}
                                                    name={classNames(
                                                        { down: componentPath },
                                                        {
                                                            right: !componentPath
                                                        }
                                                    )}
                                                    size="small"
                                                />
                                            </span>
                                        </span>
                                    </Link>

                                    <ul className="slds-navigation-list--vertical slds-has-block-links--space">
                                        {componentsStatusProdSorted.map(
                                            node => (
                                                <li
                                                    key={kebabCase(
                                                        node.component
                                                    )}
                                                    className={classNames(
                                                        'slds-list__item',
                                                        {
                                                            'slds-is-active':
                                                                componentPath ===
                                                                `${node['url-slug']}`
                                                        }
                                                    )}
                                                >
                                                    <Link
                                                        to={`/components/${node['url-slug']}/`}
                                                        className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                                        title={
                                                            node['display-name']
                                                        }
                                                    >
                                                        {node['display-name']}
                                                    </Link>
                                                </li>
                                            )
                                        )}
                                    </ul>

                                    {componentPath &&
                                    componentsStatusPrototypeSorted.length ? (
                                        <div>
                                            <h2 className="slds-text-title--caps slds-m-around--medium  slds-m-left--x-large">
                                                Prototypes
                                            </h2>
                                            <ul className="slds-navigation-list--vertical slds-has-block-links--space">
                                                {componentsStatusPrototypeSorted.map(
                                                    node => (
                                                        <li
                                                            key={kebabCase(
                                                                node.component
                                                            )}
                                                            className={classNames(
                                                                'slds-list__item',
                                                                {
                                                                    'slds-is-active':
                                                                        componentPath ===
                                                                        `${node['url-slug']}`
                                                                }
                                                            )}
                                                        >
                                                            <Link
                                                                to={`/components/${node['url-slug']}`}
                                                                className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                                                title={
                                                                    node[
                                                                        'display-name'
                                                                    ]
                                                                }
                                                            >
                                                                {
                                                                    node[
                                                                        'display-name'
                                                                    ]
                                                                }
                                                            </Link>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    ) : null}
                                </li>

                                {/* <li
								className={classNames('slds-list__item', {
									'slds-is-active': section === 'faq'
								})}
								data-slds-nav-children="false"
							>
								<Link className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate" to="/faq/"><span className="slds-media slds-media--center"><span className="slds-media__body">FAQ</span></span></Link>
							</li> */}

                                <li
                                    className={classNames('slds-list__item', {
                                        'slds-is-active':
                                            section === 'resources'
                                    })}
                                    data-slds-nav-children="false"
                                >
                                    <Link
                                        className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate"
                                        to="/resources/"
                                    >
                                        <span className="slds-media slds-media--center">
                                            <span className="slds-media__body">
                                                Resources
                                            </span>
                                        </span>
                                    </Link>
                                </li>

                                {/* <li
								className={classNames('slds-list__item', {
									'slds-is-active': section === 'registry'
								})}
								data-slds-nav-children="false"
							>
								<Link className="slds-navigation-list--vertical__action slds-text-link--reset slds-truncate" to="/registry/"><span className="slds-media slds-media--center"><span className="slds-media__body">Additional Components</span></span></Link>
							</li>
							<li className="slds-list__item"><a href="https://github.com/salesforce/design-system-react/issues"><span className="slds-media slds-media--center"><span className="slds-media__body">Log a Bug</span></span></a></li>
							<li className="slds-list__item is-closed slds-x-small-show-only">
								<a href="#top" className="slds-x-small-show-only">Back to top ^</a>
							</li>
							<li className="slds-list__item is-closed slds-small-show-only">
								<a href="#top" className="slds-small-show-only">Back to top ^</a>
							</li> */}
                            </ul>
                        </nav>
                    </aside>

                    <div className="slds-grow slds-size--1-of-1 slds-medium-size--8-of-12 slds-large-size--9-of-12 slds-col-rule--right slds-order--1 slds-small-order--1 slds-medium-order--2 slds-large-order--2 slds-p-left--large slds-p-right--large slds-p-bottom--large">
                        {React.cloneElement(props.children, { page })}
                    </div>
                </main>
            </div>
        </IconSettingsInternal>
    );
};

ComponentsLayout.displayName = 'ComponentsLayout';

ComponentsLayout.propTypes = {
    children: PropTypes.element,
    params: PropTypes.object
};

ComponentsLayout.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        pathname: ownProps.location.pathname
    };
}

export default connect(mapStateToProps)(ComponentsLayout);

// export default ComponentsLayout;



// WEBPACK FOOTER //
// ./public/src/layouts/components-layout/index.jsx